import React, {useContext} from "react";
import {Icon, Typography, Space} from "@bezlimit/bezlimit-ui";
import "./style.scss";
import {LayoutContext} from "../../../../../../../core/Contexts";
import _ from "lodash";

export default React.memo(function Phone({category, phone}: IProps) {
    const contextLayout = useContext(LayoutContext);
    return (
        <Typography as="div" className="bl-numbers-list-info-phone">
            <Space size={6}>
                <Icon name={category} size="16" />
                <Typography
                    size={_.gt(contextLayout?.width ?? 0, 375) ? 24 : 23}
                    color="#fff"
                    className="phone"
                >
                    {phone}
                </Typography>
            </Space>
        </Typography>
    );
});

interface IProps {
    category: string;
    phone: number;
}
